import { render, staticRenderFns } from "./TermsOfServiceModal.vue?vue&type=template&id=05792dba&"
import script from "./TermsOfServiceModal.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfServiceModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports